import React, { useState } from 'react';
import './PrestigeSection.css';

interface Performance {
  id: number;
  title: string;
  crew: string;
  date: string;
  thumbnail: string;
  videoUrl: string;
}

interface PrestigeSectionProps {
  content: {
    title: string;
    description: string;
    performances: Performance[];
  };
}

const PrestigeSection: React.FC<PrestigeSectionProps> = ({ content }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');

  const changeSlide = (direction: 'left' | 'right') => {
    if (isTransitioning) return;
    
    setIsTransitioning(true);
    setSlideDirection(direction);
    
    const newIndex = direction === 'right'
      ? (currentIndex + 1) % content.performances.length
      : (currentIndex - 1 + content.performances.length) % content.performances.length;
    
    setTimeout(() => {
      setCurrentIndex(newIndex);
      setIsTransitioning(false);
    }, 500);
  };

  const renderMediaContent = (performance: Performance) => {
    if (performance.videoUrl.includes('youtube.com')) {
      const youtubeId = performance.videoUrl.split('v=')[1];
      return (
        <iframe
          src={`https://www.youtube.com/embed/${youtubeId}?autoplay=0`}
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title={performance.title}
          className="performance-media"
        />
      );
    }
    return (
      <div 
        className="performance-media"
        style={{ backgroundImage: `url(${performance.thumbnail})` }}
      />
    );
  };

  return (
    <div>
      {
      

      //   <div className="prestige-slider">
      //     <button 
      //       className="slider-nav prev" 
      //       onClick={() => changeSlide('left')}
      //     >‹</button>
          
      //     <div className="slider-content">
      //       {content.performances.map((performance, index) => {
      //         const isTargetSlide = slideDirection === 'right' ? 
      //           index === (currentIndex + 1) % content.performances.length :
      //           index === (currentIndex - 1 + content.performances.length) % content.performances.length;
              
      //         if (index !== currentIndex && !isTargetSlide) return null;
              
      //         const position = index === currentIndex ? 'current' : 
      //           slideDirection === 'right' ? 'after' : 'before';
              
      //         return (
      //           <div 
      //             key={index}
      //             className={`performance-card ${position} ${
      //               isTransitioning ? `sliding-${slideDirection}` : ''
      //             }`}
      //           >
      //             {renderMediaContent(performance)}
      //           </div>
      //         );
      //       })}
      //     </div>

      //     <button 
      //       className="slider-nav next" 
      //       onClick={() => changeSlide('right')}
      //     >›</button>
      //   </div>

      //   <div className="slider-indicators">
      //     {content.performances.map((_, index) => (
      //       <button
      //         key={index}
      //         className={`indicator ${index === currentIndex ? 'active' : ''}`}
      //         onClick={() => setCurrentIndex(index)}
      //       />
      //     ))}
      //   </div>
      // </div>
      
      }
      <div className="prestige-section">
         <div className="prestige-header section-header">
           <h2>{content.title}</h2>
           <p>{content.description}</p>
        </div>
      </div>
      <blockquote 
        className="tiktok-embed" 
        cite="https://www.tiktok.com/@vdancestudio_official" 
        data-unique-id="vdancestudio_official" 
        data-embed-type="creator" 
        style={{ maxWidth: "780px", minWidth: "288px" }}
      > 
        <section> 
          <a 
            target="_blank" 
            rel="noreferrer" 
            href="https://www.tiktok.com/@vdancestudio_official?refer=creator_embed"
          >
            @vdancestudio_official
          </a> 
        </section>
      </blockquote>
    </div>
  );
};

export default PrestigeSection; 